var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.582a1.41 1.41 0 0 0 2.005 0l7.08-7.142a1.44 1.44 0 0 0 0-2.022 1.41 1.41 0 0 0-2.005 0L10 11.551 3.92 5.423a1.41 1.41 0 0 0-2.005 0 1.44 1.44 0 0 0 0 2.022l7.08 7.141.005-.004Z"
  })));
};
export default SvgChevron;